import RoomListResourcePagingResultModel from '../../generated/types/model/resource/RoomListResourcePagingResultModel';
import ISchedulerList from '../interfaces/ISchedulerList';
import BaseSchedulerListMixin from '../mixin/BaseSchedulerListMixin';

export default class RoomListResourcePagingResultViewModel extends BaseSchedulerListMixin(RoomListResourcePagingResultModel) implements ISchedulerList {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
